/** 待发货 / 未添加物流等空状态插图 */
export default function PendingIllustration() {
  return (
    <svg
      width="180"
      height="180"
      viewBox="0 0 180 180"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="90" cy="90" r="90" fill="#91D0FF" fill-opacity="0.05" />
      <circle cx="90.0014" cy="90.0014" r="57.3529" fill="#91D0FF" fill-opacity="0.1" />
      <circle cx="90.4414" cy="90.4414" r="37.5" fill="#91D0FF" fill-opacity="0.2" />
      <circle cx="90.4414" cy="90.4414" r="22.5" fill="#91D0FF" />
      <g clip-path="url(#clip0_689_9640)">
        <path
          d="M81.1758 91.7654L97.9405 83.8242L89.9993 100.589L88.2346 93.5301L81.1758 91.7654Z"
          fill="white"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_689_9640">
          <rect
            width="21.1765"
            height="21.1765"
            fill="white"
            transform="translate(78.5273 82.0586)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
